<template>
    <v-app id="inspire">
        <v-navigation-drawer
                v-model="drawer"
                :clipped="$vuetify.breakpoint.lgAndUp"
                app
        >
            <v-list dense>
                <template v-for="item in items">
                    <v-list-item :href="item.href" :key="item.text">
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.text }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                app
                color="blue darken-3"
                dark
        >
            <v-toolbar-title
                    style="width: 300px"
                    class="ml-0 pl-4"
            >
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

                <span class="hidden-sm-and-down ml-3">NR - SEO Generator</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>

        </v-app-bar>

        <v-content>
            <v-container
                    class="fill-height"
                    fluid>
                <v-row align="center"
                       justify="center">
                    <v-col cols="8">
                        <generator></generator>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
	import Generator from './components/Generator';

	export default {
		components: {
			'generator': Generator
		},
		props: {
			source: String,
		},
		data() {
			return {
				drawer: null,
				items: [
					{
						text: "nativerank.dev", icon: "arrow_back", href: "https://nativerank.dev"
					}
				]
			}
		}
	}
</script>
